module.exports = __webpack_public_path__ + "static/operations-ed9f6923c984e96a99bce582e0c56460.jpg";